export default "__VITE_ASSET__CRp3nAXt__"